import { QueryBuilderTokenType } from '../../../../../../../../../types';
import {
  ParseResultType,
  QueryExpressionParserType,
} from '../../../../../types';

export const parseBracketGroup = (
  tokens: QueryBuilderTokenType[],
  index: number,
  parseExpression: QueryExpressionParserType
): ParseResultType | null => {
  const groupedExpression = parseExpression(tokens, index);

  if (!groupedExpression) return null;

  const closingToken = tokens[groupedExpression.nextIndex];

  if (closingToken?.type !== 'bracket' || closingToken.bracket !== 'CLOSE') {
    return null;
  }

  return {
    node: groupedExpression.node,
    nextIndex: groupedExpression.nextIndex + 1,
  };
};
